<template>
  <modal-result :active-text="resultInfo?.text"
                @closeModal="closeModal"
                :active-result="activeResult"
                :active-title="resultInfo?.mainTitle">
    <modal-frame @closeModalCross="closeModal"
                 :active-title="mainTitle">
      <div class="modal-frame-input-container">
        <div class="modal-frame-input-content"
             :class="item.url"
             v-for="item in inputInfo">
          <div class="title-container Verdana-title purple-grey-title">
            {{ item.mainTitle }}
          </div>
          <input-main :info="itemInput"
                      class="big"
                      :key="itemInput.id"
                      :name-block="item.url"
                      v-for="itemInput in item.inputInfo"
                      @changeTextInput="changeTextInput"
          />
        </div>
      </div>

      <div class="modal-frame-textarea-content">
        <textarea-main :info="inputTextArea"
                    :max-text="500"
                    :name-block="'modal-frame-textarea-content'"/>
      </div>

      <div class="modal-frame-button-container">
        <button-agreement
            @changeStateAgreementButton="changeStateAgreementButton"/>
        <main-button :color="'dark'"
                     @click="submitInfo"
                     :disabled="!isValid">
          {{ btnText }}
        </main-button>
      </div>
    </modal-frame>
  </modal-result>
</template>

<script>
import MainButton from "@/components/shared/MainButton.vue";
import SubParagraph from "@/components/shared/text/SubParagraph.vue";
import InputMain from "@/components/shared/InputMain.vue";
import ModalResult from "@/components/entities/modals/layout/ModalResult.vue";
import ModalFrame from "@/components/entities/modals/layout/ModalFrame.vue";
import ButtonAgreement from "@/components/shared/button-agreement.vue";
import TextareaMain from "@/components/shared/TextareaMain.vue";
import {mapActions} from "vuex";

export default {
  name: "ModalConsulting",
  components: {
    TextareaMain,
    ButtonAgreement,
    ModalFrame,
    ModalResult,
    InputMain, SubParagraph, MainButton},

  data() {
    return {
      btnText: 'Отправить',
      resultInfo: {
        mainTitle: 'Запрос успешно отправлен',
        text: 'Представитель свяжется с Вами'
      },
      mainTitle: 'Оставить заявку',
      inputTextArea:
          {
            "id": 0,
            "placeholder": "Компания",
            "dataIndex": "company",
            "type": "text",
            "isNecessary": false
          },
      inputInfo: [
        {
          "id": 0,
          "url": "name",
          "mainTitle": "Имя",
          "inputInfo": [{
            "id": 0,
            "placeholder": "Введите имя*",
            "dataIndex": "name",
            "type": "text",
            "isNecessary": true
          }]
        },
        {
          "id": 1,
          "url": "position",
          "mainTitle": "Место работы",
          "inputInfo": [
            {
              "id": 0,
              "placeholder": "Компания",
              "dataIndex": "company",
              "type": "text",
              "isNecessary": false
            },
            {
              "id": 1,
              "placeholder": "Должность",
              "dataIndex": "position",
              "type": "text",
              "isNecessary": false
            }
          ]
        },
        {
          "id": 2,
          "url": "contacts",
          "mainTitle": "Контакты",
          "inputInfo": [
            {
              "id": 0,
              "placeholder": "your.email@provider.com*",
              "dataIndex": "email",
              "type": "text",
              "isNecessary": true
            },
            {
              "id": 1,
              "placeholder": "telegram.t.me",
              "dataIndex": "telegram",
              "type": "text",
              "isNecessary": false
            }
          ]
        }
      ],
      stateAgreementButton: false,
      resultInput: {
        name: '',
        company: '',
        position: '',
        email: '',
        telegram: '',
        message: ''
      },
      activeResult: false
    }
  },

  computed:{
    isValid() {
      return this.stateAgreementButton
          && this.resultInput.name.length
          && this.resultInput.email.length
    }
  },

  methods: {
    ...mapActions(['IS_ACTIVE_MODAL']),
    closeModal() {
      this.IS_ACTIVE_MODAL(false)
    },

    changeStateAgreementButton() {
      this.stateAgreementButton = !this.stateAgreementButton
    },

    changeTextInput(item, dataIndex) {
      this.resultInput[dataIndex] = item
    },
    submitInfo() {
      if(this.isValid) {
        console.log('submit info')
        this.activeResult = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.frame-modal-container {
  .modal-frame-button-container  {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .modal-frame-input-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    .modal-frame-input-content {
      display: flex;
      flex-direction: column;
      flex-basis: 33.33%;
    }
  }
}

@media (max-width: 3024px){
  .frame-modal-container {
    max-width: 1452px;

    .modal-frame-input-container {
      column-gap: 32px;
      .modal-frame-input-content {
        row-gap: 14px;
        .title-container {
          font-size: 22px;
        }
      }
    }
  }
}


@media (max-width: 1920px) {
  .frame-modal-container {
    max-width: 1344px;
    .modal-frame-input-container {
      column-gap: 24px;
      .modal-frame-input-content {
        row-gap: 10px;
        .title-container {
          font-size: 18px;
        }
      }
    }
  }
}

@media (max-width: 1600px) {
  .frame-modal-container {
    max-width: 960px;

    .modal-frame-input-container {
      column-gap: 16px;
      .modal-frame-input-content {
        row-gap: 8px;
        .title-container {
          font-size: 16px;
        }
      }
    }
  }
}
@media (max-height: 800px) {
  .frame-modal-container {
    max-width: 740px;

    .modal-frame-input-container {
      column-gap: 12px;
      .modal-frame-input-content {
        row-gap: 6px;
        .title-container {
          font-size: 12px;
        }
      }
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .frame-modal-container {
    max-width: 960px;

    .modal-frame-input-container {
      column-gap: 16px;
      .modal-frame-input-content {
        row-gap: 8px;
        .title-container {
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 1133px) {
  .frame-modal-container {
    max-width: 740px;

    .modal-frame-input-container {
      column-gap: 12px;
      .modal-frame-input-content {
        row-gap: 6px;
        .title-container {
          font-size: 12px;
        }
      }
    }
  }
}
@media (max-width: 769px) {
  .frame-modal-container {
    top: 0;
    left: 0;
    transform: none;
    padding: 24px 16px;
    justify-content: space-between;
    border-width: 0;
    border-radius: 0;
    max-width: 100%;
    height: 100%;

    .modal-frame-textarea-content {
      height: 100%;
    }

    .modal-frame-button-container  {
      row-gap: 12px;
      flex-direction: column;
      .main-button-container {
        width: 100%;
      }
    }

    .modal-frame-input-container {
      flex-direction: column;
      row-gap: 16px;
    }
  }
}
@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  .frame-modal-container {
    padding: 24px 20px;
  }
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}

@media (min-width: 3025px) {
  .frame-modal-container {
    max-width: 2100px;
    .modal-frame-input-container {
      column-gap: 32px;
      .modal-frame-input-content {
        row-gap: 16px;
        .title-container {
          font-size: 32px;
        }
      }
    }
  }
}

</style>